export const PUBLIC_PATH = import.meta.env.VITE_PUBLIC_PATH || '/lp/'

export const DEFAULT_TITLE = 'Whispli' as const

export const V2_RELEASE_DATE = new Date('2022-01-17T00:55:00.0Z')

